/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_QuickSearchGet } from '../models/Model_QuickSearchGet';
import type { Model_QuickSearchPost } from '../models/Model_QuickSearchPost';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class QuickSearchService {
    /**
     * @param requestBody
     * @returns Model_QuickSearchGet Success
     * @throws ApiError
     */
    public static postApiV1QuickSearches(
        requestBody?: ConvertDatesToStrings<Model_QuickSearchPost>,
    ): CancelablePromise<Array<Model_QuickSearchGet>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quickSearches',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
